import { ISearchNodesState } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Helpers/ISearchNodesState";

export const defaultSearchNodesState: ISearchNodesState = {
    searchText: "",
    filteredNodes: [],
    showFavorites: true,
    showLoadingIndicator: false,
};
